import type { CoreService, CoreServiceDTO } from 'api/coreService/coreService.types';
import parseCoreService from 'services/parseCoreService/parseCoreService';

export const parseServicesForFE = (servicesFromSubtype: CoreServiceDTO[]): CoreService[] => servicesFromSubtype.map(parseCoreService);
